export interface PolicyDocument {
  id: string; document_type: 'terms_of_service' | 'privacy_policy'; version: string;
  locale: string; title: string; content: string; is_development: boolean;
}
export async function readPolicies(id?: string): Promise<PolicyDocument[]> {
  const response = await fetch(id ? `/api/v1/policies/${encodeURIComponent(id)}` : '/api/v1/policies?locale=en');
  const body = await response.json();
  if (!response.ok) throw new Error(body.error?.message ?? 'Policies are unavailable.');
  return id ? [body.data] : body.data;
}
